class QueryBuilder {
  constructor(global) {
    this.global = global;
  }

  quote = function(text) {
    return { type: "QUOTE", text: text };
  };
  concat = function(dims, as) {
    return { type: "CONCAT", arguments: dims, as: as };
  };
  dateTrunc = function(interval, field, as) {
    return { type: "DATE_TRUNC", interval: interval, field: field, as: as };
  };

  div = function(fieldA, fieldB, as) {
    return { type: "DIV", as: as, fieldA: fieldA, fieldB: fieldB };
  };
  mult = function(fieldA, fieldB, as) {
    return { type: "MULTI", as: as, fieldA: fieldA, fieldB: fieldB };
  };
  minus = function(fieldA, fieldB, as) {
    return { type: "MINUS", as: as, fieldA: fieldA, fieldB: fieldB };
  };
  plus = function(fieldA, fieldB, as) {
    return { type: "PLUS", as: as, fieldA: fieldA, fieldB: fieldB };
  };

  sum = function(field, as) {
    return { type: "SUM", field: field, as: as };
  };
  count = function(field, as) {
    return { type: "COUNT", field: field, as: as };
  };
  countDistinct = function(field, as) {
    return { type: "COUNT_DISTINCT", field: field, as: as };
  };
  max = function(field, as) {
    return { type: "MAX", field: field, as: as };
  };
  min = function(field, as) {
    return { type: "MIN", field: field, as: as };
  };
  field = function(field) {
    return { type: "FIELD", field: field };
  };

  allOf = function(conditions) {
    return { type: "ALL_OF", conditions: conditions };
  };
  anyOf = function(conditions) {
    return { type: "ANY_OF", conditions: conditions };
  };
  not = function(condition) {
    return { type: "NOT", condition: condition };
  };
  eq = function(field, value) {
    return { type: "EQUAL", field: field, value: value };
  };
  notEq = function(field, value) {
    return { type: "NOT_EQUAL", field: field, value: value };
  };
  gt = function(field, value) {
    return { type: "GREATER_THAN", field: field, value: value };
  };
  gte = function(field, value) {
    return { type: "GREATER_THAN_OR_EQUAL", field: field, value: value };
  };
  lt = function(field, value) {
    return { type: "LESS_THAN", field: field, value: value };
  };
  lte = function(field, value) {
    return { type: "LESS_THAN_OR_EQUAL", field: field, value: value };
  };
  between = function(field, startValue, endValue) {
    return { type: "BETWEEN", field: field, start: startValue, end: endValue };
  };
  in_ = function(field, values) {
    return { type: "IN", field: field, values: values };
  };
  isNull = function(field) {
    return { type: "IS_NULL", field: field };
  };
  isNotNull = function(field) {
    return { type: "IS_NOT_NULL", field: field };
  };

  asc = function(field) {
    return { direction: "ASC", field: field };
  };
  desc = function(field) {
    return { direction: "DESC", field: field };
  };
}
export default QueryBuilder;
